// src/admin/components/ToastProvider.tsx
import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import styles from './Toast.module.css';

type Toast = { id: number; kind: 'success' | 'error' | 'info'; msg: string };
type Push = (t: Omit<Toast, 'id'>) => void;

const Ctx = createContext<Push | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<Toast[]>([]);
  const push: Push = useCallback(t => {
    const id = Date.now() + Math.random();
    setItems(prev => [...prev, { ...t, id }]);
    setTimeout(() => setItems(prev => prev.filter(x => x.id !== id)), 5000);
  }, []);
  return (
    <Ctx.Provider value={push}>
      {children}
      <div className={styles.stack} aria-live="polite">
        {items.map(t => <div key={t.id} className={`${styles.toast} ${styles[t.kind]}`}>{t.msg}</div>)}
      </div>
    </Ctx.Provider>
  );
}

export function useToast(): Push {
  const v = useContext(Ctx);
  if (!v) throw new Error('useToast must be used inside <ToastProvider>');
  return v;
}
